import * as React from 'react';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

import { Dropdown } from '@process-advisor/process-miner/components/shared/dropdown';

export const Metrics = () => {
    const [value, setValue] = React.useState<number>(1);

    const onChange = (value: number) => {
        setValue(value);
        apiProvider.applyClusterMetricFilter({metricFilter: value})
    };

    let options = [
            { value: 1, label: apiProvider.getEntityUpper() + 's' },
            { value: 2, label: 'Duration (mins)' },
            { value: 3, label: 'Duration (hrs)' },
            { value: 4, label: 'Duration (days)' },
            { value: 12, label: 'Worklogs'},
            { value: 13, label: 'Avg TimeSpent (mins)'},
            { value: 14, label: 'Total Time Spent (mins)'},
        ];

    React.useEffect(() => {
        setValue(apiProvider.getClusterMetricFilter());
    }, []);

    return (
        <Dropdown
            options={options}
            onChange={onChange}
            value={value} />
    );
};

